export default __webpack_public_path__ + "static/media/delivery.4842036d.svg";